export const WATCHER_CONTEXT = {
  LOAN_APP_INSURANCE_CTRL: 'LoanAppInsuranceCtrl',
  LOAN_FUNDING_DETAILS_CTRL: 'LoanFundingDetailsCtrl',
  LOAN_APP_LOAN_SUBMISSION_CTRL: 'LoanAppLoanSubmissionCtrl',
  SEARCHEABLE_CONTACT_SELECTOR_CTRL: 'SearcheableContactSelectorCtrl',
  ADDRESS_SELECTOR_CTRL: 'AddressSelectorCtrl',
  CONTACT_DETAILS_CTRL: 'ContactDetailsCtrl',
  CREDIT_CHECKS_LIST_CTRL: 'CreditChecksListCtrl',
};
